export function storyDownloadHref(imageUrl) {
  const raw = String(imageUrl || '').trim();
  if (!raw) return null;
  try {
    const u = new URL(raw);
    u.searchParams.set('download', '1');
    return u.toString();
  } catch {
    const sep = raw.includes('?') ? '&' : '?';
    return `${raw}${sep}download=1`;
  }
}

/** Story-tegel (9:16) als bestand opslaan. */
export async function downloadStoryImage(imageUrl, filename = '4shine-instagram-story.jpg') {
  const href = storyDownloadHref(imageUrl);
  if (!href) return false;

  try {
    const res = await fetch(href, { mode: 'cors', credentials: 'omit' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename.replace(/[^\w.\-]+/g, '_') || '4shine-instagram-story.jpg';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch {
    const a = document.createElement('a');
    a.href = href;
    a.rel = 'noopener noreferrer';
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
    return true;
  }
}
